<template>
  <button 
    class="home-button" 
    @click="goHome"
    :title="title"
  >
    <HomeIcon class="home-button__icon" />
  </button>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import HomeIcon from '@/assets/icons/home.svg'
import { useVibration } from '@/shared/utils/system/vibration'

interface Props {
  title?: string
}

withDefaults(defineProps<Props>(), {
  title: 'На главную'
})

const router = useRouter()
const { vibratePattern } = useVibration()

const goHome = async () => {
  // Вибрация при клике
  await vibratePattern('button')
  
  // Устанавливаем флаг для обновления данных на главной странице
  sessionStorage.setItem('refreshDataOnHome', 'true')
  router.push('/')
}
</script>

<style lang="scss" scoped>
.home-button {
  position: fixed;
  top: 20px;
  left: 20px;
  width: 48px;
  height: 48px;
  background: rgba(255, 255, 255, 0.9);
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 1000;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);

  &:hover {
    background: rgba(255, 255, 255, 1);
    transform: scale(1.1);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  &:active {
    transform: scale(0.95);
  }

  &__icon {
    width: 24px;
    height: 24px;
    color: #333;
  }
}

// Темная тема для некоторых страниц
.dark-theme {
  .home-button {
    background: rgba(0, 0, 0, 0.7);
    
    &:hover {
      background: rgba(0, 0, 0, 0.9);
    }
    
    &__icon {
      color: #fff;
    }
  }
}
</style>
